import React, { useState, useContext, useEffect, useNav } from "react";
import { Form, Toast } from "react-bootstrap";
import {
  ManageCensusLayout,
  LoaderWrapper,
  AddToolTip,
} from "../../../components";
import { useRouterParams } from "../../../abstracts";
import { Formik } from "formik";
import { get } from "lodash";
import { useLocation } from "react-router-dom";
import {
  FLOW_TYPES,
  usDateFormat,
  getAdvancedPathWithParam,
  MANAGE_CENSUS_ROUTES,
  MANAGE_TRANSACTION_ROUTES,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
} from "../../../utils";
import {
  setRollOverRequestToastInfo,
  manageCensusStore,
  appLayoutStore,
  setManageCensusToastInfo,
} from "../../../contexts";
import {
  getRolloverInRequestDetailsById,
  saveRolloverInRequest,
} from "../../../services";
import {
  faPencilAlt,
  faTimes,
  faTrashAlt,
} from "@fortawesome/pro-light-svg-icons";

import { globalToastInfo } from "./../../../contexts/reducers/app-layout/actions";
import { getPathWithParam } from "./../../../utils/helpers";

const RollOverSummaryContainer = (props) => {
  const { state, dispatch } = useContext(manageCensusStore);
  const [pageData, setPageData] = useState({});
  const { censusId, flow, summaryId, fromPage } = useRouterParams();
  const { history } = props;
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(1);
  const [toast1, setToast1] = useState(false);
  const paymentOptions = {
    1: "Cheque",
    2: "EFT",
  };
  const accountTypeOptions = {
    1: "Saving Account",
    2: "Checking Account",
  };

  useEffect(() => {
    setLoading(true);
    getRolloverInRequestDetailsById(parseInt(summaryId, 10))
      .then((response) => {
        if (response.isInvestmentAllocationsSameToAllSources)
          response.sourceLevelInvestments = [
            response.sourceLevelInvestments[0],
          ];
        setPageData(response);
        setStatus(response.status);
        setLoading(false);
      })
      .catch((ex) => {
        setLoading(false);
      });
  }, []);
  const onFormSubmit = () => {
    saveRolloverInRequest({
      runValidations: false,
      IsSubmit: true,
      rollOverRequestInformation: pageData,
    })
      .then((response) => {
        dispatch(
          setManageCensusToastInfo({
            showToast: true,
            toastMessage: "RolloverIn request submitted successfully",
          })
        );
        fromPage == 1
          ? history.push(
              getPathWithParam({
                path: `${MANAGE_TRANSACTION_ROUTES.PENDINGROLLOVERIN}`,
              })
            )
          : history.push(
              getAdvancedPathWithParam({
                path: `${MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS}`,
                pathParam: [flow, censusId],
              })
            );
      })
      .catch((ex) => {});
  };

  const isEdit = flow === FLOW_TYPES.EDIT;
  const buttons =
    status === 1
      ? [
          {
            label: "Previous",
            variant: "secondary",
            type: "button",
            onClick: () =>
              history.push(
                getAdvancedPathWithParam({
                  path: `${MANAGE_CENSUS_ROUTES.ROLLOVER_REQUEST}`,
                  pathParam: [flow, censusId, summaryId, fromPage],
                })
              ),
          },
          {
            label: "Cancel",
            variant: "secondary",
            type: "button",
            onClick: () =>
              history.push(
                getAdvancedPathWithParam({
                  path:
                    fromPage == 1
                      ? `${MANAGE_TRANSACTION_ROUTES.DRAFT}`
                      : `${MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS}`,
                  pathParam: fromPage == 1 ? [] : [flow, censusId],
                })
              ),
          },

          {
            label: "Submit",
            variant: "primary",
            type: "submit",
            onClick: () => {
              onFormSubmit();
            },
          },
        ]
      : [
          {
            label: "",
            variant: "link",
            type: "button",
            icon: faTimes,
            onClick: () =>
              history.push(
                getAdvancedPathWithParam({
                  path: `${MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS}`,
                  pathParam: [flow, censusId],
                })
              ),
          },
        ];

  const handleTotalForSources = (sourceInd) => {
    let sum = 0;
    if (pageData.rollOverSourceLevelContributions?.length > 0) {
      let x = pageData.rollOverSourceLevelContributions[sourceInd];
      sum = ["", NaN, undefined, null].includes(x.contributionAmount)
        ? sum + 0
        : sum + x.contributionAmount;
      sum = ["", NaN, undefined, null].includes(x.earnings)
        ? sum + 0
        : sum + x.earnings;
    }
    return sum;
  };
  const handleTotalForAllSources = () => {
    let sum = 0;
    if (pageData.rollOverSourceLevelContributions?.length > 0)
      pageData.rollOverSourceLevelContributions.forEach((x) => {
        sum = ["", NaN, undefined, null].includes(x.contributionAmount)
          ? sum + 0
          : sum + x.contributionAmount;
        sum = ["", NaN, undefined, null].includes(x.earnings)
          ? sum + 0
          : sum + x.earnings;
      });
    return sum;
  };
  const handleTotal = (sourceInd) => {
    let sum = 0;
    if (pageData.sourceLevelInvestments?.length > 0)
      pageData.sourceLevelInvestments[sourceInd].forEach(
        (x) =>
          (sum = ["", NaN, undefined, null].includes(x.investmentPercentage)
            ? sum + 0
            : sum + x.investmentPercentage)
      );
    return sum;
  };
  const CalculateSize = (size) => {
    return (size / 1024).toFixed(2) > 1000
      ? `${(size / 1024 / 1024).toFixed(2)} MB`
      : `${(size / 1024).toFixed(2)} KB`;
  };
  return (
    <LoaderWrapper isLoading={loading}>
      <ManageCensusLayout buttons={buttons} layoutHeader="New Rollover Request">
        <div style={{ overflow: "auto", height: "80vh" }}>
          <p className="plancard-header">Plan Details</p>
          <div className="summary-plan-card">
            <div className="plancard-firstblock">
              <p className="summary-planname">
                {pageData.planDetails?.name}
                {/* Fidelity's self-employed 401(k) Plan */}
              </p>
              <p className="summary-font" style={{ margin: "0px" }}>
                {pageData?.planDetails?.planId}
                {/* 12345 */}
              </p>
            </div>
            <div className="plancard-secondblock">
              <p className="summary-font  mb-3">Type</p>
              <p className="summary-font2">{pageData.planDetails?.planType}</p>
            </div>
            <div className="plancard-lastblock">
              <p className="summary-font  mb-3">Available source(s)</p>
              <p
                className="summary-font2"
                style={{
                  maxWidth: "100%",
                }}
              >
                <AddToolTip name={pageData?.planDetails?.sources}>
                  {pageData?.planDetails?.sources}
                </AddToolTip>
              </p>
            </div>
          </div>

          <div className="plan-details-container">
            <p className="plan-details-header">Distributing Plan</p>
            <div className="line-separator" />
            <p className="plan-details-header">
              Previous Plan and Company Details
            </p>
            <div className="mb-20">
              <p className="field-header">Plan name</p>
              <p className="ft-16 ftwt-500 light-grey">
                {" "}
                {pageData?.previousEmploymentDetails?.planName}
              </p>
            </div>
            <div className="mb-20">
              <p className="field-header">Plan type</p>
              <p className="ft-16 ftwt-500 light-grey">
                {pageData?.previousEmploymentDetails?.planType &&
                  OPTIONS_DATA_MAPPER.PLAN_TYPES[
                    pageData?.previousEmploymentDetails?.planType
                  ]}
              </p>
            </div>
            <div className="mb-20">
              <p className="field-header">Company name</p>
              <p className="ft-16 ftwt-500 light-grey">
                {pageData?.previousEmploymentDetails?.companyName}
              </p>
            </div>
            <p className="plan-details-header mt-50">
              Previous Trustee / Custodian Details
            </p>
            <div>
              <p className="field-header">Trustee / Custodian name</p>
              <p className="ft-16 ftwt-500 light-grey">
                {pageData?.previousEmploymentDetails?.trusteeOrCustodianName}
              </p>
            </div>
            <div>
              <p className="field-header">Bank Name</p>
              <p className="ft-16 ftwt-500 light-grey">
                {pageData?.previousEmploymentDetails?.custodianBankName}
              </p>
            </div>
            <div>
              <p className="field-header">Custodial account number</p>
              <p className="ft-16 ftwt-500 light-grey">
                {pageData?.previousEmploymentDetails?.custodianAccountNumber}
              </p>
            </div>
            <p className="plan-details-header mt-50">Rollover Amount</p>
            <div>
              <p className="field-header">Enter rollover amount</p>
              <p className="ft-16 ftwt-500 light-grey">
                ${pageData?.rolloverAmount}
              </p>
            </div>

            <div className="sourcemapping-table">
              <ul style={{ listStyle: "none", paddingRight: "20px" }}>
                <li>
                  <div className="row border-bottom mb-30">
                    <p className="ft-16 ftwt-500 dark-grey">Source Mapping</p>
                    <p className="ft-16 ftwt-500 dark-grey">Contributions</p>
                    <p className="ft-16 ftwt-500 dark-grey">Earnings</p>

                    <p className="ft-16 ftwt-500 dark-grey">Total</p>
                  </div>
                </li>
                {pageData?.rollOverSourceLevelContributions?.map(
                  (data, index) => {
                    return (
                      <li>
                        <div className="row border-bottom mb-30">
                          <p className="col-2 ft-16 dark-grey">
                            {data.sourceName}
                          </p>
                          <p>
                            $
                            {data.contributionAmount
                              ? data.contributionAmount
                              : 0}
                          </p>
                          <p>${data.earnings ? data.earnings : 0}</p>
                          <p className="ft-16 dark-grey">
                            ${handleTotalForSources(index)}
                          </p>
                        </div>
                      </li>
                    );
                  }
                )}
                <li>
                  <div className="w-90 row justifyContent mt-25">
                    <p className="col-4 bold ft-16 dark-grey">
                      Total rollover amount
                    </p>
                    <p className="bold ft-16 dark-grey">
                      ${handleTotalForAllSources()}
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            {pageData?.rothFirstContributionDate ? (
              <div>
                <p className="mt-50 field-header">
                  First contribution date for Roth
                </p>
                <p className="ft-16 ftwt-500 light-grey">
                  {usDateFormat(pageData?.rothFirstContributionDate)}
                </p>
              </div>
            ) : (
              <></>
            )}
            <p className=" mt-50 plan-details-header">Transaction details</p>
            <div className="mb-20">
              <p className="field-header">Payment mode</p>
              <p className="ft-16 ftwt-500 light-grey">
                {pageData?.rollOverTransactionInfo?.paymentMode &&
                  paymentOptions[
                    pageData?.rollOverTransactionInfo?.paymentMode
                  ]}
              </p>
            </div>
            {pageData?.rollOverTransactionInfo?.paymentMode === 1 ? (
              <div>
                <div className="mb-20">
                  <p className="field-header">Bank Name</p>
                  <p className="ft-16 ftwt-500 light-grey">
                    {
                      pageData?.rollOverTransactionInfo
                        ?.financialInstitutionName
                    }
                  </p>
                </div>

                <div className="mb-20">
                  <p className="field-header">Cheque number</p>
                  <p className="ft-16 ftwt-500 light-grey">
                    {pageData?.rollOverTransactionInfo.chequeNumber}
                  </p>
                </div>

                <div className="mb-20">
                  <p className="field-header">Routing Number</p>
                  <p className="ft-16 ftwt-500 light-grey">
                    {pageData?.rollOverTransactionInfo?.routingNumber}
                  </p>
                </div>
              </div>
            ) : null}

            {pageData?.rollOverTransactionInfo?.paymentMode === 2 ? (
              <div>
                <div className="mb-20">
                  <p className="field-header">
                    Name of the financial Institution
                  </p>
                  <p className="ft-16 ftwt-500 light-grey">
                    {
                      pageData?.rollOverTransactionInfo
                        ?.financialInstitutionName
                    }
                  </p>
                </div>

                <div className="mb-20">
                  <p className="field-header">Account Holder Name</p>
                  <p className="ft-16 ftwt-500 light-grey">
                    {pageData?.rollOverTransactionInfo?.accountHolderName}
                  </p>
                </div>

                <div className="mb-20">
                  <p className="field-header">Account Type</p>
                  <p className="ft-16 ftwt-500 light-grey">
                    {
                      accountTypeOptions[
                        pageData?.rollOverTransactionInfo?.accountType
                      ]
                    }
                  </p>
                </div>

                <div className="mb-20">
                  <p className="field-header">Account Number</p>
                  <p className="ft-16 ftwt-500 light-grey">
                    {pageData?.rollOverTransactionInfo?.accountNumber}
                  </p>
                </div>

                <div className="mb-20">
                  <p className="field-header">
                    Routing Number of Bank or Credit Union
                  </p>
                  <p className="ft-16 ftwt-500 light-grey">
                    {pageData?.rollOverTransactionInfo?.routingNumber}
                  </p>
                </div>
              </div>
            ) : null}

            <p className="ft-16 ftwt-500 dark-grey mt-50">Uploaded Documents</p>
            <div className="summary-uploaddoc">
              <div className="row" style={{ marginTop: "8px" }}>
                {pageData?.documentDetails?.length > 0 ? (
                  pageData?.documentDetails?.map((x) => {
                    return (
                      <>
                        <div
                          className="col-5"
                          style={{
                            height: "20px",
                            maxWidth: "375px",
                            borderRight: "2px solid #c0b8b8",
                            display: "flex",
                          }}
                        >
                          <i
                            class="fas fa-file-word"
                            style={{ color: "blue", fontSize: "25px" }}
                          ></i>{" "}
                          &nbsp;
                          <a
                            href={x.path}
                            target="_blank"
                            style={{ width: "60%" }}
                          >
                            {<AddToolTip name={x.fileName} />}
                          </a>
                        </div>
                        <div className="col-1">
                          <p style={{ fontSize: "15px", color: "#aca1a1" }}>
                            {CalculateSize(x.size)}
                          </p>
                        </div>
                      </>
                    );
                  })
                ) : (
                  <p>No documents uploaded</p>
                )}
              </div>
            </div>
          </div>

          {pageData?.sourceLevelInvestments?.length > 0 &&
            pageData.sourceLevelInvestments.map((data, ind) => {
              return (
                <div>
                  <p className="dark-grey ft-18 ftwt-500 mt-40">
                    {pageData.isInvestmentAllocationsSameToAllSources
                      ? "Investment Mapping"
                      : `Investment Mapping By Source - ${data[0].sourceName}`}
                  </p>

                  <div className="w-90 sourcemapping-container">
                    <ul style={{ listStyle: "none", paddingRight: "20px" }}>
                      <li>
                        <div className="row border-bottom mb-15">
                          <p className="plan-details-header">Investment name</p>
                          <p className="plan-details-header">Percentage</p>
                        </div>
                      </li>
                      {data.map((item, index) => {
                        const fieldName = `sourceLevelInvestments.${ind}.${index}.investmentPercentage`;
                        return (
                          <li>
                            <div
                              className="row border-bottom mb-15"
                              //style={{ marginRight: "25px" }}
                            >
                              <p className="dark-grey ft-16">
                                {item.investmentName}
                              </p>
                              <p className="dark-grey ft-16 ftwt-500">
                                {item.investmentPercentage}%
                              </p>
                            </div>
                          </li>
                        );
                      })}

                      <li>
                        <div className="w-90 row justifyContent mt-25">
                          <p className="bold dark-grey ft-16">
                            Total Percentage
                          </p>
                          <p className="bold dark-grey ft-16">
                            {handleTotal(ind)}%
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              );
            })}
        </div>
      </ManageCensusLayout>
    </LoaderWrapper>
  );
};
export default RollOverSummaryContainer;
